export const ErrorCodes = {
    STORAGE_LIMIT_REACHED : 21007,
  }